<template>
  <base-list-overview
    controller="Monitor"
    :visible="visible"
  />
</template>

<script>
import BaseListOverview from '@/components/shared/base/base-list-overview'
import ContentMixin from '@/mixins/content-mixin'

export default {
  name: 'MonitorsOverview',
  components: {
    BaseListOverview
  },
  mixins: [
    ContentMixin
  ]
}
</script>
